import {Form} from "@/utils/Form";
import {CreateFaxMutation, CreateFaxMutationVariables, useCreateFaxMutation} from "../mutations.generated";
import {Auth, ContextFilters, useAuth} from "@/context/AuthProvider";
import {showNotification} from "@/actions";
import {defineMessage} from "react-intl";
import {Link} from "@/components/widgets";

export class CreateFaxForm extends Form<CreateFaxMutation, CreateFaxMutationVariables> {
    private auth: Auth;
    private domainName: string;

    constructor(domainId: number, domainName: string, password: string, successItemPath: string) {
        super("createFax");
        this.domainName = domainName;

        this.hooks(
            useCreateFaxMutation,
            {
                domainId,
                e164: null,
                shortNumber: "",
                outgoingCallBarringOperator: [],
                outgoingCallBarringAdmin: [],
                incomingEmailAddress: "",
                senderEmailAddress: "",
                password,
                notifyUnsuccessfulReceiving: true,
                additionalFaxSendingEmails: [],
            },
            (_form) =>
                showNotification(
                    defineMessage({id: "fax_created", defaultMessage: "Fax {link} has been successfully created."}),
                    "success",
                    {
                        link: (
                            <Link to={`/domains/${domainId}/${successItemPath}/${_form.result.data.createFax.id}`}>
                                {_form.values.shortNumber}
                            </Link>
                        ),
                    },
                    10000,
                ),
            (_) =>
                showNotification(
                    defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}),
                    "error",
                    null,
                    10000,
                ),
        );

        this.auth = useAuth();
    }

    protected override get filteredVariables(): CreateFaxMutationVariables {
        const values = structuredClone(this.values);

        if (!this.auth.hasPermission("add_fax_superuser", ContextFilters.domain(this.domainName))) {
            delete values.outgoingCallBarringOperator;
        }

        return values;
    }
}
